export const institutionProfileTranslations = {
  lv: {
    title: 'Iestādes profils',
    settings: 'Iestatījumi',
    subtitle:
      'Šie dati nonāk prakses līgumos. Ja kāds no tiem trūkst, līgumam būs statuss “Trūkst datu”.',
    information: 'Informācija',
    contacts: 'Atbildīgais par praksēm',
    logo: 'Logotips',
    noLogo: 'Nav logo',
    edit: 'Rediģēt',
    save: 'Saglabāt',
    saved: 'Saglabāts',
    upload: 'Augšupielādēt',
    remove: 'Dzēst',
    removed: 'Logotips dzēsts',
    required: 'Lauks ir obligāts',
    invalidEmail: 'Ievadiet derīgu e-pasta adresi',
    logoHint: 'PNG vai JPEG līdz 3,5 MB',
    logoError: 'Izvēlieties PNG vai JPEG attēlu līdz 3,5 MB.',
    confirmRemove: 'Dzēst logotipu?',
    removeHint: 'Iestādes logotips tiks noņemts. Vēlāk varēsiet augšupielādēt jaunu attēlu.',
    loadError: 'Neizdevās ielādēt iestādes profilu',
    logoLoadError: 'Neizdevās ielādēt logotipu',
    fields: {
      name: 'Nosaukums',
      address: 'Adrese',
      webSite: 'Mājas lapa',
      regNo: 'Reģistrācijas numurs',
      vatNo: 'PVN numurs',
      email: 'E-pasts',
      phone: 'Tālrunis',
    },
  },
  en: {
    title: 'Institution profile',
    settings: 'Settings',
    subtitle:
      'These details appear in internship agreements. Missing details may prevent an agreement from being generated.',
    information: 'Information',
    contacts: 'Internship contact',
    logo: 'Logo',
    noLogo: 'No logo',
    edit: 'Edit',
    save: 'Save',
    saved: 'Saved',
    upload: 'Upload',
    remove: 'Delete',
    removed: 'Logo deleted',
    required: 'This field is required',
    invalidEmail: 'Enter a valid email address',
    logoHint: 'PNG or JPEG up to 3.5 MB',
    logoError: 'Choose a PNG or JPEG image up to 3.5 MB.',
    confirmRemove: 'Delete the logo?',
    removeHint: 'The institution logo will be removed. You can upload a new image later.',
    loadError: 'Could not load the institution profile',
    logoLoadError: 'Could not load the logo',
    fields: {
      name: 'Name',
      address: 'Address',
      webSite: 'Website',
      regNo: 'Registration number',
      vatNo: 'VAT number',
      email: 'Email',
      phone: 'Phone',
    },
  },
}
